import Lock from "@mui/icons-material/Lock";
import { Chip } from "@mui/material";

import type { ChipProps } from "@mui/material";
import type { FC } from "react";

export const RestrictedChip: FC<ChipProps> = ({ ...props }) => (
  <Chip
    variant="outlined"
    size="small"
    color="warning"
    icon={<Lock />}
    label="RESTRICTED"
    {...props}
  />
);
